import HttpService from './baseHttp'

// 根据采购单号获得采购明细
export const HttpPurchaseNos = (data) => HttpService.get('/api/v2/Inbound/getPoItemsByPoNos', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据采购明细获得产品明细
export const HttpSavePurchaseList = (data) => HttpService.post('/api/v2/Inbound/getProductItemsByPoItems', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })




// 创建头程物流提交
export const HttpSaveLogisticsOne = (data) => HttpService.post('/api/v2/LogisticsHead/createLogisticsOrder', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })

// 更新头程物流 &&（创建头程物流之后进入的页面提交）
export const HttpUpdateLogisticsOne = (data) => HttpService.post('/api/v2/LogisticsHead/updateLogisticsOrder', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })

// 提交审核头程物流
export const HttpSubmitSaveLogisticsOne = (data) => HttpService.post('/api/v2/LogisticsHead/saveAndSubmitLogistics', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })

// 查看单条头程物理
export const HttpSeeLogisticsOne = (data) => HttpService.post('/api/v2/LogisticsHead/getLogisticHeadInfo', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 创建物流单选择单据带出工厂信息
export const HttpSeeLogisticsHeadFactory = (data) => HttpService.get('/api/v2/LogisticsHead/getFactoryInfoByInbound', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })




// 头程物流列表
export const HttpLogisticsList = (data) => HttpService.post('/api/v2/LogisticsHead/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 取消单条物流
export const HttpCancelLogisticsOne = (data) => HttpService.post('/api/v2/LogisticsHead/cancelLogisticsOrder', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 提交单条物流
export const HttpSubmitLogisticsOne = (data) => HttpService.post('/api/v2/LogisticsHead/submitOrder', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 查看物流弹框
export const HttpSeeLogisticsHistory = (data) => HttpService.post('/api/v2/LogisticsHead/getShipmentDetail', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 入库计划单下拉框
export const HttpInboundOrderList = (data) => HttpService.get('/api/v2/Inbound/inboundPlanOrderNoList', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });




// 实时查询采购单号
export const HttpPurchaseNoList = (data) => HttpService.get('/api/v2/po/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 根据多个采购单请求采购单弹框详情
export const HttpPurchaseDetail = (data) => HttpService.get('/api/v2/Inbound/getPoItemsByPoNos', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 查询地址列表
export const HttpAddressList = (data) => HttpService.get('/api/v2/address/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 是否展示采购单导入按钮
export const HttpShowPurchase = (data) => HttpService.get('/api/v2/Inbound/isImportProductsFromPo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 创建物流选择入库单号请求项目名字
export const HttpGetLineName = (data) => HttpService.get('/api/v2/Inbound/getLineByInboundPlanOrderNosAndProductItemCount', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 更新物流单据
export const HttpUpdateLogistics = (data) => HttpService.post('/api/v2/logisticsRecord/addRecord', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB })

// 物流单据指定负责人
export const HttpSetDesignatedPerson = (data) => HttpService.post('/api/v2/LogisticsHead/designatedPerson', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 头程物流货代端列表
export const HttpGetHeadLogisticsAdmin = (data) => HttpService.post('/api/v2/LogisticsHead/findByPageByForwarder', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 获取所有仓库-分页
export const HttpGetAllWareHouse = (data) => HttpService.get('/api/v2/organizationWarehouse/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetAllProduct = (data) => HttpService.get('/api/v1/ProductLine/findAllWithOutOrg', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取所有项目
export const HttpGetAllOrg =  (data, config) => HttpService.post('/api/v1/Organization/selectByPage', data, { ...config, baseURL: process.env.VUE_APP_APIURL_UC })

// 获取仓库
export const HttpWarehouse =  (data) => HttpService.get('/api/v2/warehouse/findAllWarehouses', data, { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 根据单号获取入库计划单详情
export const HttpGetDetailByNos =  (data) => HttpService.get('/api/v2/Inbound/detailByNo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 修改最新预计到仓时间
export const HttpChangeArriveDate = (data) => HttpService.post('/api/v2/LogisticsHead/updateNewestEstimateArriveDate', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 货代列表
export const HttpGetCompanyList = (data) => HttpService.get('/api/v2/Supplier/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS})

// 根据供应商id获取payment
export const HttpGetSupplierById = (data) => HttpService.get('/api/v2/Supplier/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// paymentterm详情
export const HttpGetPaymentDetail = (data = {}) => HttpService.get('/api/v1/arap/paymentTerm/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })